export const successFeaturesRequest = (featureToggles) => ({
  type: "FEATURES_GET_SUCCESS",
  payload: {
    featureToggles
  }
});

export const failFeaturesRequest = (err) => ({
  type: "FEATURES_GET_FAIL",
  payload: err,
  error: true
});

export const featuresResponse = (features) => ({
  type: "FEATURES_RESPONSE",
  payload: {
    features
  }
});

export const successMessagesRequest = (messagesData) => ({
  type: "MESSAGES_GET_SUCCESS",
  payload: {
    messages: messagesData
  }
});

export const successSeoMessagesRequest = (name, content) => ({
  type: "SEO_MESSAGES_GET_SUCCESS",
  payload: {
    name,
    content
  }
});

export const failMessagesRequest = (err) => ({
  type: "MESSAGES_GET_FAIL",
  payload: err,
  error: true
});

export const abTestingChange = (feature, enabled) => ({
  type: "SET_ABTESTING_TOGGLE",
  payload: {
    featureName: feature,
    enabled
  }
});
